import { combineReducers } from 'redux'
import exampleReducer from './exapleReducer';

const reducers = combineReducers({
    example: exampleReducer
})

export default reducers; 